namespace Matrix.Data {
    export interface AccountRoleRow {
        AccountRoleCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace AccountRoleRow {
        export const idProperty = 'AccountRoleCode';
        export const nameProperty = 'AccountRoleCode';
        export const localTextPrefix = 'Data.AccountRole';
        export const lookupKey = 'Data.AccountRole';

        export function getLookup(): Q.Lookup<AccountRoleRow> {
            return Q.getLookup<AccountRoleRow>('Data.AccountRole');
        }
        export const deletePermission = 'DataAdmin:AccountRole';
        export const insertPermission = 'DataAdmin:AccountRole';
        export const readPermission = 'Read:AccountRole';
        export const updatePermission = 'DataAdmin:AccountRole';

        export declare const enum Fields {
            AccountRoleCode = "AccountRoleCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
